/**
 * Tenant Branding Configuration Interface
 * Used for public-facing pages to maintain consistent branding
 */
export interface TenantBranding {
  // Hero section
  heroTitle?: string;
  heroSubtitle?: string;
  heroImageUrl?: string;
  
  // SEO and social
  ogImageUrl?: string;
  orgShortDescription?: string;
  
  // Visual identity
  logoUrl?: string;
  faviconUrl?: string;
  
  // Theme colors
  primaryColor?: string;
  secondaryColor?: string;
  accentColor?: string;
  
  // Typography (future enhancement)
  fontFamily?: string;
}

/**
 * Default branding values for tenant-neutral fallbacks
 */
export const DEFAULT_BRANDING: TenantBranding = {
  heroTitle: "Upcoming Events",
  heroSubtitle: undefined,
  heroImageUrl: undefined,
  ogImageUrl: undefined,
  orgShortDescription: undefined,
  logoUrl: undefined,
  faviconUrl: "/favicon.ico",
  primaryColor: "#3B82F6", // blue-500
  secondaryColor: "#6B7280", // gray-500
  accentColor: "#10B981", // emerald-500
};

/**
 * Merge tenant branding with defaults
 */
export function mergeBrandingWithDefaults(branding?: TenantBranding | null): TenantBranding {
  return {
    ...DEFAULT_BRANDING,
    ...branding,
  };
}

/**
 * Generate CSS custom properties from branding
 */
export function brandingToCSSProperties(branding: TenantBranding): Record<string, string> {
  return {
    '--color-primary': branding.primaryColor || DEFAULT_BRANDING.primaryColor!,
    '--color-secondary': branding.secondaryColor || DEFAULT_BRANDING.secondaryColor!,
    '--color-accent': branding.accentColor || DEFAULT_BRANDING.accentColor!,
  };
}









